/**
* View Model to handle presentation of calendar integration requests
*
* @class CalendarIntegrationViewModel
*/
function CalendarIntegrationViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  // Creates a conventional reference to 'this'
  self.prelinkResourceId = ko.observable(null);
  self.confirmResendResourceId = ko.observable(null);
  self.resendResourceId = ko.observable(null);
  self.requestEmail = ko.observable(null);
  self.resendEmail = ko.observable(null);
  self.resources = ko.observableArray([]);
  self.selectedLocationsResources = ko.observableArray([]);
  self._selectedProvider = {}

  // Possible consent statuses
  var CONSENT_STATUS_WAITING = "waiting"
  var CONSENT_STATUS_FAILED = "failed"
  var CONSENT_STATUS_ACCEPTED = "accepted"

  self.singleProvider = ko.computed(function () {
    var properties = self.parent.environmentProperties()
    var isGoogleProviderEnabled = (
      properties["cia.googleIntegration.enabled"] == "true" 
      || properties['cia.googleIntegration.enabled'] == true
    );

    if (!isGoogleProviderEnabled) {
      return self.PROVIDERS.OFFICE365;
    }

    return false;
  }, self, {deferEvaluation: true}) 

  self.selectedProvider = function (id) {
    if (!id) {
      return null;
    }

    var provider = self._selectedProvider[id];
    if (typeof provider === 'undefined') {
      provider = ko.observable(null);
      provider(self.selectedProviderForResource(id))
      self._selectedProvider[id] = provider;
    }
    return provider;
  }

  self.selectedProviderForResource = function (resourceId) {
    var resource = self.resources().filter(function(r) {
      return r.resourceId == resourceId
    }).pop()


    return (resource) ? resource.integrationProvider.toLowerCase() : null;
  }

  /**
   * Checks if the resouce has failed calendar integration
   *
   * @method isConsentFailed
   * @returns {Array}
   */
  self.isConsentFailed =  function(status) {
    return (status.toLowerCase() === CONSENT_STATUS_FAILED);
  }

  /**
   * Checks if the resouce has accepted calendar integration
   *
   * @method isConsentAccepted
   * @returns {Array}
   */
  self.isConsentAccepted =  function(status) {
    return (status.toLowerCase() === CONSENT_STATUS_ACCEPTED);
  }

  /**
   * Checks if the resouce is waiting to accept calendar integration
   *
   * @method isWaitingForConsent
   * @returns {Array}
   */
  self.isWaitingForConsent =  function(status) {
    return (status.toLowerCase() === CONSENT_STATUS_WAITING);
  }


  /**
   * Collection of consents with FAILED status
   *
   * @method failedResources
   * @returns {Array}
   */
  self.failedResources = ko.computed(function () {
    return self.resources().filter(function (resource) {
      return self.isConsentFailed(resource.consentStatus) && self.locationIsSelected(resource.locationId);
    });
  });


  /**
   * Collection of consents with ACCEPTED status
   *
   * @method linkedResources
   * @returns {Array}
   */
  self.linkedResources = ko.computed(function () {
    return self.resources().filter(function (resource) {
      return self.isConsentAccepted(resource.consentStatus) && self.locationIsSelected(resource.locationId);
    });
  }, self, { deferEvaluation: true });


  /**
   * Returns true is the location passed is currently selected
   *
   * @method locationIsSelected
   * @returns {Boolean}
   */
  self.locationIsSelected = function (locationId) {
    return self.parent.selectedLocationIds().indexOf(locationId.toString()) >= 0;
  }

  /**
   * Collection of resources without any consent records
   *
   * @method nonLinkedResources
   * @returns {Array}
   */
  self.nonLinkedResources = ko.computed(function () {
    var resourceList = self.parent.selectedLocationIds().length > 0 ? self.selectedLocationsResources() : self.parent.resources();
    var resourceIds = resourceList.map(function (r) { return r.id });
    var linkedResourceIds = self.linkedResources().map(function (r) { return r.resourceId });

    return resourceList.filter(function (calendarResource) {
      var exists = resourceIds.indexOf(calendarResource.id) >= 0  
      var isNotLinked = linkedResourceIds.indexOf(calendarResource.id) === -1; 
      return  exists && isNotLinked 
    }, self, { deferEvaluation: true });
  });


  /**
   * Collection of consents with WAITING status
   *
   * @method pendingResources
   * @returns {Array}
   */
  self.pendingResources = ko.computed(function () {
    return self.resources().filter(function (resource) {
      return self.isWaitingForConsent(resource.consentStatus) && self.locationIsSelected(resource.locationId);
    });
  });


  /**
   * Collection of consents with REJECTED status
   *
   * @method rejectedResources
   * @returns {Array}
   */
  self.rejectedResources = ko.computed(function () {
    return self.resources().filter(function (resource) {
      return resource.consentStatus.toUpperCase() === 'REJECTED' && self.locationIsSelected(resource.locationId);
    });
  });


  /**
   * Gets a list of consents and statuses
   *
   * @method getResources
   * @returns none
   */
  self.getResources = function () {
    var ws = new AbstractWS(self.parent);
    ws.name = 'cia';
    ws.dataType = 'json';
    ws.serviceURL = ko.observable('/qless/api/v2/cia/consent');
    ws.processData = function (json) {
      AbstractWS.prototype.processData.call(ws, json);

      json = json.reduce(function (arr, itm) {
        var resource = qcal.resourcesWS.getResourceById(itm.resourceId);
        if (resource) {
          itm.name = resource.name;
          itm.locationId = resource.locationId();
          itm.location = resource.location();
          itm.nameWithLocation = itm.name + " - " + itm.location;
          arr.push(itm);
        }
        return arr;
      }, []);
      self.resources(json);
    }
    ws.doRequest();
  };

  /**
   * hides the remove consent confirmation dialog
   *
   * @method hideConsent
   * @returns none
   */

  self.hideConsent = function () {
    self.confirmResendResourceId(null);
  }


  /**
   * Sets up the UI to accept an email for linking
   *
   * @method prelink
   * @param {ResourceModel} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.prelink = function (data, evt) {
    self.requestEmail(null);
    self.prelinkResourceId(data.id);
  };

  /**
   * Sets up the UI to accept an email for resending consent
   *
   * @method prelinkResend
   * @param {ResourceModel} data
   * @param {MouseEvent} evt
   * @returns none
   */

  self.prelinkResend = function (data, evt) {
    var selectedProvider = self.selectedProvider(data.resourceId)
    selectedProvider(data.integrationProvider.toLowerCase())
    self.resendEmail(data.email);
    self.resendResourceId(data.resourceId);
  }

   /**
   * Sets up the UI to confirm if a user would like to remove CIA consent
   *
   * @method confirmRemoveConsent
   * @param {ResourceModel} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.confirmRemoveConsent = function (data, evt) {
    self.confirmResendResourceId(data.resourceId);
  }

  /**
   * Returns the name of the resource based on the number of selected locations.
   * If there is more than one selected location, the name will be returned with the location name.
   *
   * @method qualifiedResourceName
   * @returns {String}
   */
  self.qualifiedResourceName = function (data) {
    if (self.parent.selectedLocationIds().length > 1) {
      return data.nameWithLocation ? data.nameWithLocation : data.name + " - " + data.location();
    } else {
      return data.name;
    }
  };

  /**
   * Removes consent for the selected resource Id
   *
   * @method removeConsent
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.removeConsent = function (data, evt) {
    var ws = new AbstractWS(self.parent);
    ws.name = 'cia';
    ws.dataType = 'json';
    ws.method('DELETE');
    ws.serviceURL = ko.observable('/qless/api/v2/cia/consent/' + data.resourceId);
    ws.processData = function (json) {
      AbstractWS.prototype.processData.call(ws, json);
      self.getResources();
    }
    ws.doRequest();
  };

  /**
   * Requests consent for a resource
   *
   * @method requestConsent
   * @param {ResourceModel} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.requestConsent = function (data, evt) {
    if (data && data.id && self.requestEmail()) {
      var ws = new AbstractWS(self.parent);
      var provider = (self.singleProvider()) ? self.singleProvider() : self.selectedProvider(data.id)()
      ws.name = 'cia';
      ws.dataType = 'json';
      ws.params = JSON.stringify({
        emailAddress: self.requestEmail(),
        resourceId: data.id
      });
      ws.method('POST');

      ws.serviceURL = ko.observable(self.API_URLs.requestAuthorization(provider));
      ws.processData = function (json) {
        AbstractWS.prototype.processData.call(ws, json);
        self.getResources();
      }
      ws.doRequest();

      self.unprelink(data);
    }
  };

    /**
   * Resends requests consent for a resource
   *
   * @method resendConsent
   * @param {ResourceModel} data
   * @returns none
   */
  self.resendConsent = function (data, evt) {
    if (data && data.resourceId && self.resendEmail()) {
      var ws = new AbstractWS(self.parent);
      var selectedProvider = (self.singleProvider()) ? self.singleProvider() : self.selectedProvider(data.resourceId)()
      var provider = self.providers(selectedProvider);
      ws.name = 'cia';
      ws.dataType = 'json';
      ws.params = JSON.stringify({
        emailAddress: self.resendEmail(),
        resourceId: data.resourceId
      });
      ws.method('POST');
      ws.serviceURL = ko.observable(self.API_URLs.requestAuthorization(provider));
      ws.processData = function (json) {
        AbstractWS.prototype.processData.call(ws, json);
        self.getResources();
      }
      ws.doRequest();

      self.preresend(data);
    }
  };

  /**
   * Collection of resources for the selected locations
   *
   * @method setSelectedLocationsResources
   * @returns {Array}
   */
  self.setSelectedLocationsResources = ko.computed(function() {
    var resources = self.parent.resources().filter( function (resource) {
      return self.parent.selectedLocationIds().indexOf(resource.locationId().toString()) >= 0
    });
    self.selectedLocationsResources(resources)
  });

  /**
   * Sets up the UI to accept an email for linking
   *
   * @method unprelink
   * @param {ResourceModel} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.unprelink = function (data, evt) {
    self.prelinkResourceId(null);
    self.selectedProvider(data.id)(null);
    self.requestEmail(null);
  };

  /**
   * Sets up the UI to resend an email for linking
   *
   * @method preresend
   * @param {ResourceModel} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.preresend = function (data, evt) {
    self.resendResourceId(null);
    self.resendEmail(null);
    self.selectedProvider(data.resourceId)(null);
  };

  return self;
};

CalendarIntegrationViewModel.prototype = Object.create(AbstractViewModel.prototype);
CalendarIntegrationViewModel.prototype.constructor = CalendarIntegrationViewModel;

// NOTE: These constants only work for the API end-point.
// The `integrationProvider` value returned for a resource, from the API, is either 'Google' or 'Office',
// not 'Office365'.
CalendarIntegrationViewModel.prototype.PROVIDERS = {
  'GOOGLE': 'google',
  'OFFICE365': 'office365',
  'OFFICE': 'office365'
};

CalendarIntegrationViewModel.prototype.providers = function (p) {
  return this.PROVIDERS[p.toUpperCase()]
}

CalendarIntegrationViewModel.prototype.API_URLs = {
  requestAuthorization: function (provider) { return "/qless/api/v2/cia/[provider]/request-authorization-uri".replace("[provider]", provider) },
  consent: function (resourceId) { return '/qless/api/v2/cia/consent/[resourceId]'.replace("[resourceId]", resourceId) },
}

CalendarIntegrationViewModel.prototype.linkedProviderIcons = {
  'google': 'res/imgs/ci-logo-google-24.png',
  'office': 'res/imgs/ci-logo-outlook-24.png',
}

CalendarIntegrationViewModel.prototype.providerLabels = {
  'google': 'Google Calendar',
  'office': 'Microsoft Outlook',
}

/**
 * 
 * @param {string} provider 
 * @returns string 
 */
CalendarIntegrationViewModel.prototype.getLinkedProviderIcon = function(provider) {
  var key = provider.toLowerCase();
  return this.linkedProviderIcons[key];
}

CalendarIntegrationViewModel.prototype.providerLabel = function(provider) {
  var key = provider.toLowerCase();
  return this.providerLabels[key];
}

if (typeof exports !== 'undefined') {
  exports.CalendarIntegrationViewModel = CalendarIntegrationViewModel;
}
